import logger from 'src/logger';
import withProps from 'recompose/withProps';
import * as productTracking from '../../analytics/category/product';
import * as accountTracking from '../../analytics/category/account';

export const withSetupTracking = withProps(props => {
  try {
    productTracking.init(props.productId, props.analyticsContext);
    accountTracking.init(props.analyticsContext);
  } catch (error) {
    logger.error(error);
  }
});

export default withSetupTracking;
